import Vue from 'vue'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

// or, using the defaults with no stylesheet
Vue.use(VueVideoPlayer);